import { RouteLocationNormalized } from 'vue-router';
import { useCoreStore } from 'src/stores/core/store';
import { BreadcrumbItem } from '@/stores/core/models';
import useRouteUtils from '../router-utils/route-utils';
import useBreadcrumbs from '../composable/use-breadcrumbs';
import { IRouteMetaResolveResults } from '../models/routing';

const breadcrumbAfterEachGuard = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const toMeta = to.meta as IRouteMetaResolveResults;
  if (toMeta.isRouteCanceled) return;
  if (from.fullPath == to.fullPath) return;

  const coreStore = useCoreStore();
  //let reset = coreStore.resetBreadcrumbs;

  const { arePathFirstSegmentsDifferent } = useRouteUtils();
  const { buildBreadcrumbItems } = useBreadcrumbs();
  let items = await buildBreadcrumbItems(to);
  const reset = arePathFirstSegmentsDifferent(from.fullPath, to.fullPath);

  if (reset) {
    coreStore.breadcrumbItems = [...items];
  } else {
    let storeLastModuleIndex = (coreStore.breadcrumbItems as any).findLastIndex((x: BreadcrumbItem) => x.routeLevel === 1);
    let storeLastModuleBreadcrumbs = coreStore.breadcrumbItems.slice(storeLastModuleIndex);

    let startLevelToAdd = -1;
    items.some((item) => {
      const relatedStoreLevelItem = (storeLastModuleBreadcrumbs as any).findLast((x: any) => x.routeLevel == item.routeLevel);
      if (!relatedStoreLevelItem || relatedStoreLevelItem.route != item.route) {
        startLevelToAdd = item.routeLevel;
        return true; // break
      }
    });

    if (startLevelToAdd === -1) {
      if (items.length && storeLastModuleBreadcrumbs.length) {
        const laststoreItem = storeLastModuleBreadcrumbs[storeLastModuleBreadcrumbs.length - 1];
        if (laststoreItem.routeLevel == 4 && items[items.length - 1].routeLevel == 3) {
          // we navigate from level 4 to 3.
          startLevelToAdd = 3;
        } else if (laststoreItem.routeLevel == 3 && items[items.length - 1].routeLevel == 4) {
          // we navigate from level 3 to 4
          startLevelToAdd = 4;
        }
      }
      if (startLevelToAdd === -1) startLevelToAdd = 1;
    }

    items = items.filter((x) => x.routeLevel >= startLevelToAdd);
    coreStore.breadcrumbItems = [...coreStore.breadcrumbItems, ...items];

    // keep only last 8
    if (coreStore.breadcrumbItems.length > 8) {
      coreStore.breadcrumbItems = coreStore.breadcrumbItems.slice(-8);
    }
  }
};

export default breadcrumbAfterEachGuard;
